import Cookies from "js-cookie";
import {TOKEN_COOKIE} from "./constants";


export default function isUserAuthenticated() {
  return Cookies.get(TOKEN_COOKIE) !== undefined;
}